/* eslint-disable */

import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

function useCXPageView() {
  const location = useLocation();

  const tituloPagina = useSelector(state => state.app.tituloPagina);
  const lastPathnameRef = useRef(null);

  useEffect(() => {

    if (tituloPagina !== lastPathnameRef.current && tituloPagina != "Grupo de Serviços") {
      lastPathnameRef.current = tituloPagina;

      const cxDataObject = {
        "dcsuri": location.pathname,
        "wt.ti": tituloPagina
      }

      window.ORA = window.ORA || { productReady: [] };
      ORA.productReady.push(['analytics', function (cxDataObject) { return function () { return ORA.view({ "data": cxDataObject }) } }(cxDataObject)]);
    }
  }, [location.pathname, tituloPagina]);
}

export default useCXPageView;
